export class PageableSearch<T> {
	content: T[]
	first: boolean
	last: boolean
	number: number
	numberOfElements: number
	size: number
	totalElements: number
	totalPages: number
}


// WEBPACK FOOTER //
// ./src/app/models/pageable-search.model.ts